import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestBase } from '../../base/request-base';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { MyDataManager } from '../../helpers/data-manager';
import * as AppConst from '../../data/test.data';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { UrlParams } from '../../helpers/url-params';
import { SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { saveAs as importedSaveAs } from "file-saver";


@Component({
    selector: 'request-internal',
    templateUrl: './request-internal.html',
})
export class RequestInternalComponent extends RequestBase implements OnInit, OnDestroy {

    dateFormat: string = 'dd/MM/yyyy';
    nameValueFields: Object = { value: 'Value', text: 'Name' };
    objSearch: any = {};

    constructor(auth: AuthenService, http: HttpService, httpClient: HttpClient, helper: HelperService
        , notify: NotifyService, translate: TranslateService, router: Router, route: ActivatedRoute, private sidebar: SidebarService, @Inject('BASE_URL') public baseUrl: string) {
        super(auth, http, httpClient, helper, notify, translate, router, route, baseUrl);

        this.keywordSCSearch = this.auth.LoginUser;
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        if (this.subsNotify)
            this.subsNotify.unsubscribe();
    }

    ngOnInit() {
        
        this.init();
        this.onSearch();
        //this.data = this.http.getByManager(`api/Request/GetPage`, this.auth);
    }

    onSearch() {
       
        let params = new UrlParams();
        params.addDate('fromDate', this.fromDate);
        params.addDate('toDate', this.toDate);
        params.add('requestTypes', Util.array2String1(this.requestTypesSelected, ';'), '');
        params.add('requestStatus', this.requestStatusSelected, '');
        params.add('custSearch', this.keywordCustomerSearch, '');
        params.add('scSearch', this.keywordSCSearch, '');
        params.add('requestCode', this.requestCodeSearch, '');
        params.add('userName', this.auth.LoginUser, '');
        params.add('userType', this.auth.GroupUserCode, '');
        params.add('area', Util.array2String1(this.areaSelected, ','), '');


        this.data = this.http.getByManager(`api/Request/SearchRequestForInternal/${params.toString()}`, this.auth);


        this.initParamSearch();



    }

    onActionBegin(evt: any) {
        // console.log(evt);

        //if (evt.requestType == 'sorting') {
        //    console.log(evt.columnName);
        //    console.log(evt.direction);
        //    console.log(evt);
        //}
    }
    onClearSearch() {
        this.requestStatusSelected = null;
        //this.requestTypeSelected = null;
        this.fromDate = null;
        this.toDate = null;
        this.keywordCustomerSearch = null;
        if (this.auth.GroupUserCode == 'SC') {
            this.keywordSCSearch = this.auth.UserNameInternal;
        } else {
            this.keywordSCSearch = null;
        }
        this.requestCodeSearch = null;
        this.requestTypesSelected = [];
        this.areaSelected = [];
        this.checkAreaMList = false;
        this.checkRequestTypeMList = false;
        this.onSearch();
    }

    onCheckAllRequestType(evt: ChangeEventArgs) {
        this.enableRequestTypeList = true;//!evt.checked;

        if (evt.checked) {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = true;
            this.requestTypeMList.forEach(p => {
                this.requestTypesSelected.push(p.Value);
            });
        } else {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = false;
        }
        //this.ngRefresh();
    }

    onCheckAllArea(evt: ChangeEventArgs) {
        this.enableAreaList = true;//!evt.checked;

        if (evt.checked) {
            this.areaSelected = [];
            this.checkAreaMList = true;
            this.areaMList.forEach(p => {
                this.areaSelected.push(p);
            });
        } else {
            this.areaSelected = [];
            this.checkAreaMList = false;
        }
    }

    onExportRequestInternal() {

        let paramsExport = new UrlParams();
        paramsExport.addDate('fromDate', this.fromDate);
        paramsExport.addDate('toDate', this.toDate);
        paramsExport.add('requestTypes', Util.array2String1(this.requestTypesSelected, ';'), '');
        paramsExport.add('requestStatus', this.requestStatusSelected, '');
        paramsExport.add('custSearch', this.keywordCustomerSearch, '');
        paramsExport.add('scSearch', this.keywordSCSearch, '');
        paramsExport.add('requestCode', this.requestCodeSearch, '');
        paramsExport.add('userName', this.auth.LoginUser, '');
        paramsExport.add('userType', this.auth.GroupUserCode, '');
        paramsExport.add('area', Util.array2String1(this.areaSelected, ','), '');


        this.isProcessingChangeStatus = true;
        this.http.downloadSelections(`api/Request/ExportInternalRequest/${paramsExport.toString()}`, null, res => {
            let fileNameExport = 'Request-Internal-Export.xlsx';
            importedSaveAs(res, fileNameExport);
            this.isProcessingChangeStatus = false;
        });

    }




}



